import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { Row, Column } from 'elc-grid';

interface IProductGridHeaders {
    productGridHeader?: string;
    productGridSubheader?: string;
}

export const StyledHeaderColumn = styled(Column)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const productGridHeaderWrapper = classes('product-grid-header-wrapper');
const productGridHeaderClassnames = classes('product-grid-header');
const productGridSubheaderClassnames = classes('product-grid-subheader');

export const ProductGridHeaders = observer((props: IProductGridHeaders) => {
    const { productGridHeader, productGridSubheader } = props;

    if (!productGridHeader && !productGridSubheader) {
        return null;
    }

    return (
        <Row>
            <StyledHeaderColumn className={productGridHeaderWrapper}>
                {productGridHeader && (
                    <div className={productGridHeaderClassnames}>{productGridHeader}</div>
                )}
                {productGridSubheader && (
                    <div className={productGridSubheaderClassnames}>{productGridSubheader}</div>
                )}
            </StyledHeaderColumn>
        </Row>
    );
});
